import {Component, OnInit} from '@angular/core';
import {AuthData} from '../../models/auth-status';
import {AuthService} from '../../services/auth.service';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { filter } from 'rxjs';
import { AlertController, ModalController } from '@ionic/angular';
import { filteredTab } from 'src/app/utils/menu.helper';

@Component({
    selector: 'app-footer-toolbar',
    templateUrl: './footer-toolbar.component.html',
    styleUrls: ['./footer-toolbar.component.scss'],
})
export class FooterToolbarComponent implements OnInit {
    displayedTab: any[];

    constructor(
        private readonly authService: AuthService,
    ) { }

    ngOnInit() {
        this.authService.authStatus.pipe(filter(status => status?.authDone)).subscribe((status) => {
            this.displayedTab = filteredTab(status);
        });
    }
}
